(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["a-buy-together-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-buy-together-products')) {
		class LTABuyTogetherProducts extends HTMLElement {
			constructor() {
				super()

				this.onButtonClick = this.onButtonClick.bind(this)
				this.isLoading = false
				this.items = []
			}

			connectedCallback() {
				this.buttonEl = this.querySelector('.l-bUProducts__button')
				this.itemsScriptEl = this.querySelector('[data-buy-together-items]')

				if (!this.buttonEl || !this.itemsScriptEl) return

				this.items = this.itemsScriptEl ? JSON.parse(this.itemsScriptEl.textContent) : []

				console.log(this.items)

				this.buttonEl.addEventListener('click', this.onButtonClick)
			}

			disconnectedCallback() {
				this.buttonEl && this.buttonEl.removeEventListener('click', this.onButtonClick)
			}

			getCartService() {
				return window.ltaCartService || (typeof ltaCartService !== 'undefined' ? ltaCartService : null)
			}

			setLoadingState(isLoading) {
				this.isLoading = isLoading

				if (!this.buttonEl) return

				if (isLoading) {
					this.buttonEl.setAttribute('disabled', 'disabled')
					this.buttonEl.setAttribute('aria-busy', 'true')
					return
				}

				this.buttonEl.removeAttribute('disabled')
				this.buttonEl.removeAttribute('aria-busy')
			}

			async onButtonClick() {
				const cartService = this.getCartService()
				if (this.isLoading || !cartService) return

				if (!this.items.length) return

				this.setLoadingState(true)

				try {
					const config = cartService.createConfigFromItems(this.items)
					await cartService.addToCart(config, 'buy-together-products')
				} finally {
					this.setLoadingState(false)
				}
			}
		}

		customElements.define('l-buy-together-products', LTABuyTogetherProducts)
	}
  } catch(e) { console.error(e); }
})();

})();
